/* ============================================================
   JEFFS FURNITURE — Elite PDP  |  pdp-elite.js
   Chunk 2: Hero Slideshow Engine
   ============================================================ */

(function () {
  'use strict';

  /* ── Wait for DOM ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPDP);
  } else {
    initPDP();
  }

  function initPDP() {
    initHero();
    initScrollHint();
  }

  /* ══════════════════════════════════════════
     HERO SLIDESHOW
  ══════════════════════════════════════════ */
  function initHero() {
    const hero   = document.getElementById('pdp-hero');
    if (!hero) return;

    const slides  = Array.from(hero.querySelectorAll('.pdp-hero__slide'));
    const thumbs  = Array.from(hero.querySelectorAll('.pdp-hero__thumb'));
    const counters = Array.from(hero.querySelectorAll('.pdp-hero__counter-num'));
    const prevBtn = document.getElementById('pdp-prev');
    const nextBtn = document.getElementById('pdp-next');

    if (slides.length < 2) return; /* single image — no slideshow needed */

    let current  = 0;
    let timer    = null;
    let paused   = false;
    const INTERVAL = 5500; /* ms between auto-advance */

    /* ── Core: go to a specific slide ── */
    function goTo(index) {
      /* Wrap around */
      index = (index + slides.length) % slides.length;

      /* Deactivate current */
      slides[current].classList.remove('is-active');
      if (thumbs[current])   thumbs[current].classList.remove('is-active');
      if (counters[current]) counters[current].classList.remove('is-active');

      /* Activate new */
      current = index;
      slides[current].classList.add('is-active');
      if (thumbs[current])   thumbs[current].classList.add('is-active');
      if (counters[current]) counters[current].classList.add('is-active');
    }

    /* ── Auto-advance ── */
    function startTimer() {
      stopTimer();
      timer = setInterval(function () {
        if (!paused) goTo(current + 1);
      }, INTERVAL);
    }

    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    /* ── Button events ── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
        startTimer(); /* reset interval on manual nav */
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(current + 1);
        startTimer();
      });
    }

    /* ── Thumbnail clicks ── */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const idx = parseInt(thumb.dataset.thumbIndex, 10);
        goTo(idx);
        startTimer();
      });
    });

    /* ── Pause on hover ── */
    hero.addEventListener('mouseenter', function () { paused = true;  });
    hero.addEventListener('mouseleave', function () { paused = false; });

    /* ── Touch swipe support ── */
    let touchStartX = 0;
    hero.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      paused = true;
    }, { passive: true });

    hero.addEventListener('touchend', function (e) {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
        startTimer();
      }
      setTimeout(function () { paused = false; }, 2000);
    }, { passive: true });

    /* ── Keyboard navigation ── */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { goTo(current - 1); startTimer(); }
      if (e.key === 'ArrowRight') { goTo(current + 1); startTimer(); }
    });

    /* ── Start ── */
    startTimer();
  }

  /* ══════════════════════════════════════════
     SCROLL HINT — clicking it scrolls to info
  ══════════════════════════════════════════ */
  function initScrollHint() {
    const hint = document.getElementById('pdp-scroll-hint');
    if (!hint) return;

    function scrollDown() {
      const hero   = document.getElementById('pdp-hero');
      const target = hero ? hero.offsetTop + hero.offsetHeight : window.innerHeight;
      window.scrollTo({ top: target, behavior: 'smooth' });
    }

    hint.addEventListener('click', scrollDown);
    hint.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') scrollDown();
    });

    /* Hide scroll hint once user has scrolled past hero */
    window.addEventListener('scroll', function () {
      const hero = document.getElementById('pdp-hero');
      if (!hero) return;
      const past = window.scrollY > hero.offsetHeight * 0.3;
      hint.style.opacity = past ? '0' : '';
      hint.style.pointerEvents = past ? 'none' : '';
    }, { passive: true });
  }

})();
/* ============================================================
   CHUNK 3 — Scroll Reveal + Description Toggle
   Append this to the bottom of pdp-elite.js
   (keep the existing hero code above, add this below)
   ============================================================ */

/* ── Run chunk 3 init alongside existing initPDP ── */
document.addEventListener('DOMContentLoaded', function () {
  initScrollReveal();
  initDescToggle();
});

/* ══════════════════════════════════════════
   SCROLL REVEAL
   Watches .pdp-reveal elements and adds
   .is-visible when they enter the viewport
══════════════════════════════════════════ */
function initScrollReveal() {
  const revealEls = document.querySelectorAll('.pdp-reveal');
  if (!revealEls.length) return;

  if (!('IntersectionObserver' in window)) {
    /* Fallback for old browsers — just show everything */
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); /* fire once, then stop watching */
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px'
  });

  revealEls.forEach(function (el) { observer.observe(el); });
}

/* ══════════════════════════════════════════
   DESCRIPTION TOGGLE
   Collapses long descriptions to ~200px
   and reveals on "Read more" click
══════════════════════════════════════════ */
function initDescToggle() {
  var toggle = document.getElementById('pdp-desc-toggle');
  var inner  = document.getElementById('pdp-desc-inner');
  if (!toggle || !inner) return;

  /* If description is short enough, hide the toggle entirely */
  if (inner.scrollHeight <= 220) {
    toggle.style.display = 'none';
    inner.style.maxHeight = 'none';
    return;
  }

  var label = toggle.querySelector('span');
  var open  = false;

  toggle.addEventListener('click', function () {
    open = !open;
    inner.classList.toggle('is-expanded', open);
    toggle.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open);
    if (label) label.textContent = open ? 'Read less' : 'Read more';
  });
}
/* ============================================================
   CHUNK 4 — Variant Picker + Quantity + Add to Cart
   Append this to the bottom of pdp-elite.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  initVariantPicker();
  initQuantity();
  initATC();
});

/* ══════════════════════════════════════════
   VARIANT PICKER
   Reads the variants JSON Shopify outputs,
   matches selected options → finds correct
   variant → updates price, availability,
   hidden form input and URL
══════════════════════════════════════════ */
function initVariantPicker() {
  var jsonEl = document.getElementById('pdp-variants-json');
  if (!jsonEl) return;

  var variants    = JSON.parse(jsonEl.textContent);
  var pills       = document.querySelectorAll('.pdp-option__pill');
  var selects     = document.querySelectorAll('.pdp-option__select');
  var selectedOpts = buildCurrentOptions();

  /* ── Build initial selected options from active pills ── */
  function buildCurrentOptions() {
    var opts = [];
    document.querySelectorAll('.pdp-option').forEach(function (row) {
      var idx    = parseInt(row.dataset.optionIndex, 10);
      var active = row.querySelector('.pdp-option__pill.is-active');
      var sel    = row.querySelector('.pdp-option__select');
      if (active) {
        opts[idx] = active.dataset.value;
      } else if (sel) {
        opts[idx] = sel.value;
      }
    });
    return opts;
  }

  /* ── Find matching variant for current options ── */
  function findVariant(opts) {
    return variants.find(function (v) {
      return opts.every(function (val, i) {
        return v['option' + (i + 1)] === val;
      });
    }) || null;
  }

  /* ── Update UI to reflect chosen variant ── */
  function updateVariant() {
    var variant = findVariant(selectedOpts);

    /* Update hidden form input */
    var input = document.getElementById('pdp-variant-id');
    if (input && variant) input.value = variant.id;

    /* Update URL without page reload */
    if (variant && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({ variantId: variant.id }, '', url.toString());
    }

    /* Update price */
    updatePrice(variant);

    /* Update availability */
    updateAvailability(variant);

    /* Update ATC button */
    updateATC(variant);
  }

  /* ── Price update ── */
  function updatePrice(variant) {
    var priceEl   = document.querySelector('.pdp-info__price');
    var compareEl = document.querySelector('.pdp-info__price--compare');

    if (!variant || !priceEl) return;

    var formatter = new Intl.NumberFormat(
      document.documentElement.lang || 'en',
      { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }
    );

    priceEl.textContent = formatter.format(variant.price / 100);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.classList.add('pdp-info__price--sale');
      if (compareEl) {
        compareEl.textContent = formatter.format(variant.compare_at_price / 100);
        compareEl.style.display = '';
      }
    } else {
      priceEl.classList.remove('pdp-info__price--sale');
      if (compareEl) compareEl.style.display = 'none';
    }

    /* Update hero price overlay too */
    var heroPrice = document.querySelector('.pdp-hero__price-value');
    if (heroPrice) heroPrice.textContent = formatter.format(variant.price / 100);
  }

  /* ── Availability update ── */
  function updateAvailability(variant) {
    var dot  = document.querySelector('.pdp-availability__dot');
    var text = document.getElementById('pdp-avail-text');
    if (!dot || !text) return;

    dot.className = 'pdp-availability__dot';

    if (!variant || !variant.available) {
      dot.classList.add('pdp-availability__dot--out');
      text.textContent = 'Sold out';
    } else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
      dot.classList.add('pdp-availability__dot--low');
      text.textContent = 'Only ' + variant.inventory_quantity + ' left';
    } else {
      dot.classList.add('pdp-availability__dot--in');
      text.textContent = 'In stock';
    }
  }

  /* ── ATC button state ── */
  function updateATC(variant) {
    var btn      = document.getElementById('pdp-atc');
    var btnText  = btn ? btn.querySelector('.pdp-atc__text') : null;
    if (!btn) return;

    if (!variant || !variant.available) {
      btn.disabled = true;
      btn.classList.add('is-sold-out');
      if (btnText) btnText.textContent = 'Sold Out';
    } else {
      btn.disabled = false;
      btn.classList.remove('is-sold-out');
      if (btnText) btnText.textContent = 'Add to Cart';
    }
  }

  /* ── Pill click handler ── */
  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.classList.contains('is-unavailable')) return;

      var idx = parseInt(pill.dataset.optionIndex, 10);

      /* Deactivate siblings */
      pill.closest('.pdp-option__pills')
          .querySelectorAll('.pdp-option__pill')
          .forEach(function (p) { p.classList.remove('is-active'); });

      /* Activate clicked */
      pill.classList.add('is-active');
      selectedOpts[idx] = pill.dataset.value;

      /* Update selected label */
      var label = document.getElementById('pdp-option-selected-' + idx);
      if (label) label.textContent = pill.dataset.value;

      updateVariant();
    });
  });

  /* ── Dropdown select handler ── */
  selects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      var idx = parseInt(sel.dataset.optionIndex, 10);
      selectedOpts[idx] = sel.value;

      var label = document.getElementById('pdp-option-selected-' + idx);
      if (label) label.textContent = sel.value;

      updateVariant();
    });
  });
}

/* ══════════════════════════════════════════
   QUANTITY STEPPER
══════════════════════════════════════════ */
function initQuantity() {
  var input   = document.getElementById('pdp-quantity');
  var btnDown = document.getElementById('pdp-qty-down');
  var btnUp   = document.getElementById('pdp-qty-up');
  if (!input) return;

  btnDown && btnDown.addEventListener('click', function () {
    var val = parseInt(input.value, 10) || 1;
    if (val > 1) input.value = val - 1;
  });

  btnUp && btnUp.addEventListener('click', function () {
    var val = parseInt(input.value, 10) || 1;
    input.value = val + 1;
  });

  /* Prevent non-numeric input */
  input.addEventListener('input', function () {
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) input.value = 1;
  });
}

/* ══════════════════════════════════════════
   ADD TO CART
   Submits via AJAX so page doesn't reload.
   Shows loading → added → resets states.
   Updates cart count in header if present.
══════════════════════════════════════════ */
function initATC() {
  var form    = document.querySelector('.pdp-form');
  var btn     = document.getElementById('pdp-atc');
  var errBox  = document.getElementById('pdp-form-error');
  if (!form || !btn) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (btn.disabled) return;

    var variantId = document.getElementById('pdp-variant-id');
    var quantity  = document.getElementById('pdp-quantity');

    if (!variantId || !variantId.value) {
      showError('Please select all options before adding to cart.');
      return;
    }

    /* Loading state */
    btn.classList.add('is-loading');
    hideError();

    var body = JSON.stringify({
      id:       parseInt(variantId.value, 10),
      quantity: parseInt(quantity ? quantity.value : 1, 10)
    });

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    body
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Could not add to cart.'); });
      return res.json();
    })
    .then(function () {
      /* Success state */
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.querySelector('.pdp-atc__text').textContent = '✓ Added to Cart';

      /* Update cart count bubble in header */
      updateCartCount();

      /* Reset button after 2.5s */
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.querySelector('.pdp-atc__text').textContent = 'Add to Cart';
      }, 2500);
    })
    .catch(function (err) {
      btn.classList.remove('is-loading');
      showError(err.message || 'Something went wrong. Please try again.');
    });
  });

  function showError(msg) {
    if (!errBox) return;
    errBox.textContent = msg;
    errBox.classList.add('is-visible');
  }

  function hideError() {
    if (!errBox) return;
    errBox.classList.remove('is-visible');
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Works with most themes — targets common cart count selectors */
        var selectors = [
          '.cart-count',
          '.cart__count',
          '[data-cart-count]',
          '.header__cart-count',
          '#cart-count',
          '.pdp-cart-count'
        ];
        selectors.forEach(function (s) {
          document.querySelectorAll(s).forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
      })
      .catch(function () { /* silently fail cart count update */ });
  }
}
// In pdp-elite.js
document.getElementById('pdp-scroll-btn')?.addEventListener('click', () => {
  document.getElementById('pdp-info')?.scrollIntoView({ behavior: 'smooth' });
});
// Auto-hide swipe hint after 3 animation cycles (2.5s x 3 = 7.5s)
const swipeHint = document.getElementById('pdp-swipe-hint');
if (swipeHint) {
  setTimeout(() => {
    swipeHint.classList.add('is-hidden');
  }, 9000); // 1.5s delay + 7.5s animation

  // Also hide on first thumb click — user already knows
  document.querySelectorAll('.pdp-hero__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      swipeHint.classList.add('is-hidden');
    });
  });
}
const heroTint = document.getElementById('pdp-hero-tint');

setTimeout(() => {
  swipeHint?.classList.add('is-hidden');
  if (heroTint) heroTint.style.display = 'none';
}, 9000);

document.querySelectorAll('.pdp-hero__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    swipeHint?.classList.add('is-hidden');
    if (heroTint) heroTint.style.display = 'none';
  });
});

const prevBtn = document.getElementById('pdp-arrow-prev');
const nextBtn = document.getElementById('pdp-arrow-next');

function getActiveIndex() {
  const active = document.querySelector('.pdp-hero__slide.is-active');
  return active ? parseInt(active.dataset.slideIndex) : 0;
}

function goToSlide(index) {
  const slides = document.querySelectorAll('.pdp-hero__slide');
  const total = slides.length;
  const newIndex = (index + total) % total;
  slides.forEach(s => s.classList.remove('is-active'));
  if (slides[newIndex]) slides[newIndex].classList.add('is-active');
}

if (prevBtn) prevBtn.addEventListener('click', () => goToSlide(getActiveIndex() - 1));
if (nextBtn) nextBtn.addEventListener('click', () => goToSlide(getActiveIndex() + 1));